import React from 'react';
import { ArrowRight } from 'lucide-react';

interface ThankYouProps {
  onReset: () => void;
}

export default function ThankYou({ onReset }: ThankYouProps) {
  return (
    <div className="max-w-md mx-auto text-center">
      <div className="mb-8 flex justify-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-green-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-800 mb-2">
        Thank You!
      </h2>
      
      <p className="text-gray-600 mb-8">
        Your feedback has been successfully recorded. We appreciate your time and input, which will help us improve our designs.
      </p>
      
      <button
        onClick={onReset}
        className="inline-flex items-center px-6 py-3 bg-blue-500 text-white font-medium rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-300"
      >
        Take Another Test
        <ArrowRight className="ml-2 h-4 w-4" />
      </button>
    </div>
  );
}